//
// Flattens a Qr code menu, from this style:
//
// menu={
//   "emergency": [
//     {
//       "code": "malaise",
//       "type": "reportEnd"
//     },
//     {
//       "code": "smoke",
//       "type": "reportEnd"
//     },
//
// to this style (ready to inject in Table):
//
// menuFlattened=[
//   {
//     "ccatCode": "safety",
//     "depth": 0,
//     "key": "0",
//     "end": false,
//     "path": "/safety"
//   },
//   {
//     "ccatCode": "emergency",
//     "depth": 1,
//     "key": "0_0",
//     "end": false,
//     "path": "/safety/emergency"
//   },
//   {
//     "ccatCode": "malaise",
//     "depth": 2,
//     "key": "0_0_0",
//     "end": true,
//     "path": "/safety/emergency/malaise"
//   },

const flattenQrMenu = (
  qrMenus,
  newFlatQrMenu,
  code,
  depth,
  key,
  parentPath,
  parentLvl,
) => {
  const items = qrMenus[code];

  if (!items) return;

  items.forEach((menuItem, index) => {
    const thisKey = (depth)
      ? `${key}_${index}`
      : `${index}`;
    const { code: thisCode } = menuItem;

    let thisPath;
    if (parentPath) thisPath = `${parentPath}/${thisCode}`;
    else thisPath = `/${thisCode}`;

    const end = !(qrMenus[thisCode] && qrMenus[thisCode].length);

    // A code without its own entry inherits its parent branch's level; root default is 2.
    const lvl = (qrMenus.info?.[thisCode]?.level) ?? parentLvl ?? 2;

    // console.log(`${thisPath}: ${end}`);
    newFlatQrMenu.push({
      ccatCode: thisCode,
      depth,
      key: thisKey,
      end,
      path: thisPath,
      lvl,
      index: newFlatQrMenu.length,
    });

    if (!end) {
      flattenQrMenu(
        qrMenus,
        newFlatQrMenu,
        thisCode,
        depth + 1,
        thisKey,
        thisPath,
        lvl,
      );
    }
  });
};

export default flattenQrMenu;
